export default {"src":"/_next/static/media/laptop_friendly_workspace.8d89a910.svg","height":100,"width":100};